import $ from 'jquery';
import { Formatter } from '@dealersites/dealersite-js-core';
import { InventorySearchEvents } from '@dealersites/inventory/events';
import { dspCalculatePayment } from './dsp-calculator';

const frequencies = {
  biweekly: 'BIW',
  weekly: 'Weekly',
  monthly: 'Monthly'
}


export function oemFinance(finance, item, disclaimer = null, frequency = 'biweekly') {

  const terms = [];
  let disclaimerDetails = disclaimer;
  let price = item.lowest_price;
  let totalFinanceIncentives = 0;
  let payment = 0;

  const values = finance.value;
  for (let key in values) {
    terms.push(values[key]);
  }

  terms.sort((a, b) => (a.value < b.value ? 1 : -1));
  terms.sort((a, b) => (a.from < b.from ? 1 : -1));
  const setTerms = terms[0];



  if (finance.cash.length) {
    const financeIncentives = finance.cash;
    for (let key in financeIncentives) {
      if (!financeIncentives[key].optional) {
        totalFinanceIncentives += financeIncentives[key].value;
      }
    }
  }

  price = price - totalFinanceIncentives;

  let calcInputs = {
    price: price,
    down: 0,
    term: setTerms.from,
    rate: setTerms.value,
    tradein: 0,
    tax: 0,
  };

  if (disclaimerDetails.adjustPayments) {
    calcInputs.tax = parseInt(disclaimerDetails.tax);
  }

  payment = dspCalculatePayment(calcInputs, 'finance', frequency);

  return payment;
 
}

export function oemLease(lease, item, disclaimer = null, frequency = 'biweekly') {

  const terms = [];
  const values = lease.value;
  let disclaimerDetails = disclaimer;
  let price = item.lowest_price;
  let residualPrice = item.price;
  let totalLeaseIncentives = 0;
  let payment = 0;

  for (let key in values) {
    terms.push(values[key]);
  }

  terms.sort((a, b) => (a.value < b.value ? 1 : -1));
  terms.sort((a, b) => (a.from < b.from ? 1 : -1));
  const setTerms = terms[0];

  const residualAmount = residualPrice * (setTerms.residual_value / 100);

  if (residualAmount) {
    
    if (lease.cash.length) {
      const leaseIncentives = lease.cash;
      for (let key in leaseIncentives) {
        if (!leaseIncentives[key].optional) {
          totalLeaseIncentives += leaseIncentives[key].value;
        }
      }
    }

    price = price - totalLeaseIncentives

    let calcInputs = {
      price: price,
      down: 0,
      term: setTerms.from,
      rate: setTerms.value,
      tradein: 0,
      tax: 0,
      residual: residualAmount,
    };
 

    if (disclaimerDetails.adjustPayments) {
      calcInputs.tax = parseInt(disclaimerDetails.tax);
    }

    payment = dspCalculatePayment(calcInputs, 'lease', frequency);
    return payment;

  } else {
    return false;
  }
}


// Simple (SRP) //

function runSrpPayments() {

  
  $('.js-payment').each(function (index) {
    let $payment = $(this);
    let calcInputs = {
      price: $payment.data('price'),
      down: $payment.data('down'),
      term: $payment.data('term'),
      rate: $payment.data('rate'),
      tradein: $payment.data('tradein'),
    };

    const calculatorType = $payment.data('calculator-type');
    const includeTax = $payment.data('include-tax');
    const tax = parseInt($payment.data('tax'));
    const frequency = $payment.data('frequency');
  
    calcInputs.tax = includeTax ? tax : 0;
    
    if (calculatorType === 'lease') {
      calcInputs.residual = $payment.data('residual');
    }

   const payment = dspCalculatePayment(calcInputs, calculatorType, frequency );
   $payment.text( `${Formatter.price(payment, 0)} /${frequencies[frequency]}` );
 
  });
}

runSrpPayments();

$(document).on(InventorySearchEvents.POST_RENDER, function() {
  runSrpPayments();
})
